import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRunShortcut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconRunShortcut"><Path fillRule="evenodd" clipRule="evenodd" d="M3 5.5C3 4.11929 4.11929 3 5.5 3H18.5C19.8807 3 21 4.11929 21 5.5V18.5C21 19.8807 19.8807 21 18.5 21H5.5C4.11929 21 3 19.8807 3 18.5V5.5ZM14.7069 6.04482C14.9583 6.15909 15.0695 6.45551 14.9552 6.7069L9.95518 17.7069C9.84091 17.9583 9.54449 18.0695 9.2931 17.9552C9.04171 17.8409 8.93055 17.5445 9.04482 17.2931L14.0448 6.2931C14.1591 6.04171 14.4555 5.93055 14.7069 6.04482Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRunShortcut;
